<template>
  <div>
    <Mastermap :imgSrc='masterMap.imgSrc' :companyName='masterMap.companyName' :masterTitle='masterMap.masterTitle'>
    </Mastermap>
    <div class="container">
      <div class="area">
        <div class="item" v-for="(item,i) in caseList" :key="i">
          <img :src="item.imgSrc" alt="">
          <h2>{{item.title}}</h2>
          <p>{{item.subTitle}}</p>
          <div @click="chdekContent(i)">
            <span>查看详情</span>
            <img src="../assets/img/triangle.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Mastermap from '../components/Mastermap.vue'
export default {
  name: 'SucessCase',
  components: {
    Mastermap
  },
  data () {
    return {
      masterMap: {
        imgSrc: require('../assets/img/case.jpg'),
        companyName: '产品案例',
        masterTitle: '产品创造于工厂，而品牌创造于心灵',
        subTitle: ''
      },
      caseList: [{
        imgSrc: require('../assets/img/shifen_h.png'),
        title: '石分达人',
        subTitle: '石分达人以垃圾分类桶站为切入点，采用“线上小程序+线下智能硬件”相结合的方式，以…'
      }, {
        imgSrc: require('../assets/img/rubbish.png'),
        title: '垃圾分类监管平台',
        subTitle: '在充分整合桶站智能巡查、垃圾站点视频监控、地理信息系统、车辆运输数据、清洁站…'
      }, {
        imgSrc: require('../assets/img/city_regulation.png'),
        title: '城市管理运行平台',
        subTitle: '通过物联网、云计算等新一代信息技术在城市管理重点领域的创新应用，依托与GIS，建设...'
      }, {
        imgSrc: require('../assets/img/nb.jpg'),
        title: '南水阀井远程无线监测',
        subTitle: '通过对阀井内温度、湿度、水位、是否有人员进入等情况的实时监测工作，从而实现阀井…'
      }
      ]
    }
  },
  methods: {
    chdekContent (i) {
      this.$router.push({
        path: '/casedetails',
        query: {
          id: i
        }
      }).catch(err => { console.log(err) })
    }
  },
}
</script>

<style lang="less" scoped>
.container {
  display: flex;
  justify-content: center;
  margin-top: 60px;
  .area {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .item {
      display: flex;
      flex-direction: column;
      width: 372px;
      background-color: #fff;
      margin: 10px;
      img {
        height: 210px;
      }
      h2,
      p,
      div {
        margin: 0px 20px;
      }
      h2 {
        margin-top: 20px;
        font-size: 18px;
      }
      p {
        margin-top: 10px;
        line-height: 30px;
      }
      div {
        margin: 20px 0 20px 15px;
        padding: 3px;
        border-radius: 5px;
        width: 80px;
        span {
          margin-left: 5px;
          font-size: 14px;
          color: #002fa7;
        }
        img {
          margin-left: 8px;
          width: 8px;
          height: 12px;
        }
      }
      div:hover {
        background-color: rgb(247, 244, 240);
        cursor: pointer;
      }
    }
  }
}
</style>